// V3 starts as an independent deep clone of V2's data, then applies V3-only
// overrides. Future V3 experiments can mutate this without affecting V2.
import { EYE_REPAIR } from "@/data/eyeRepair";

const clone =
  typeof structuredClone === "function"
    ? structuredClone(EYE_REPAIR)
    : JSON.parse(JSON.stringify(EYE_REPAIR));

// V3-only flags
clone.v3 = true;
clone.galleryStickyFirst = false;     // legacy layout flag — off
clone.galleryOneSkin = true;          // OneSkin-style: LEFT gallery scrolls, RIGHT buy box sticky
clone.showLightComparison = false;    // hide "Why Riversol Is Different" (light)
clone.showBlueComparison = true;      // keep the blue one
clone.routineWideBanner = true;       // wider left banner + thumb-style products

// Extra gallery images so the tile grid rows are all filled (2 per row on the last row)
const F = "https://cdn.shopify.com/s/files/1/0821/1399/files";
clone.gallery = [
  ...clone.gallery,
  { src: `${F}/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698`, alt: "Eye Repair Treatment lifestyle", label: "In use" },
];

// V3 Before/After result mockup (used inside RiversolInAction's split layout)
clone.beforeAfter = {
  eyebrow: "Real Results",
  heading: "8 weeks with Eye Repair",
  copy: "Drag to compare — same participant, same lighting. Individual results vary.",
  before: `${F}/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698`,
  after: `${F}/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698`,
  note: "Sample — replace with real before/after imagery",
};

export const EYE_REPAIR_V3 = clone;
export default EYE_REPAIR_V3;
